import { RecipeInstructions } from '@mindfulchefuk/features/Recipes/interfaces'

export function hasAllRecipeStepTitles(
  instructions: RecipeInstructions[]
): boolean {
  return instructions.every((step) => step.title)
}
